function hulkapps_custom_init() {
    const hulkFormulaEle = document.querySelector('.hulk-custom-formula');
    
    const CONFIG = {
      pricingData: {
        "50cl": {
          "base_pricing": {
            "0": 8.95,
            "5": 8.95,
            "10": 8.50,
            "25": 7.95,
            "50": 7.50
          },
          "flavor_1": 0.41,
          "flavor_2": 0.41,
          "coloring_cost": 0.29,
          "min_abv": 20,
          "max_abv": 50
        },
        "70cl": {
          "base_pricing": {
            "0": 11.50,
            "5": 11.50,
            "10": 11.00,
            "25": 9.50,
            "50": 8.95
          },
          "flavor_1": 0.58,
          "flavor_2": 0.58,
          "coloring_cost": 0.41,
          "min_abv": 20,
          "max_abv": 50
        }
      },
      shippingRates: {
        "5": 24.95,
        "10": 39.95,
        "25": 89.95,
        "50": 149.95
      },
      productDevelopmentCosts: {
        "SAMPLE": 162.50,
        "default": 0
      },
      vatRate: 0.20,
      dutyRates: {
        highAbv: 32.79, // Rate for ABV > 22%
        lowAbv: 29.54   // Rate for ABV <= 22%
      },
      volumeMap: {
        '50cl': 0.5,
        '70cl': 0.7
      },
      // New configuration for bar calculations
      barConfig: {
        rrpOfBar: 4.5,
        shotsThreshold: 11.00, // bottle price threshold for shots calculation
        shotsIfAtThreshold: 28,
        shotsOtherwise: 20
      }
    };
  
    /**
     * Calculate duty based on bottle size and ABV
     * bottleSize - Bottle size ('50cl' or '70cl')
     * minAbv - Minimum ABV
     * maxAbv - Maximum ABV
     * @returns {Object} Duty table with ABV as keys and duty amounts as values
     */
    function calculateDuty(bottleSize, minAbv, maxAbv) {
      const volume = CONFIG.volumeMap[bottleSize];
      if (!volume) {
        console.error(`Invalid bottle size: ${bottleSize}`);
        return {};
      }
      
      const dutyTable = {};
      
      for (let abv = minAbv; abv <= maxAbv; abv++) {
        const rate = abv > 22 ? CONFIG.dutyRates.highAbv : CONFIG.dutyRates.lowAbv;
        const dutyAmount = (rate * volume * abv) / 100;
        dutyTable[abv] = parseFloat(dutyAmount.toFixed(2));
      }
      
      return dutyTable;
    }
  
    CONFIG.pricingData["50cl"].duty_table = calculateDuty("50cl", 20, 50);
    CONFIG.pricingData["70cl"].duty_table = calculateDuty("70cl", 20, 50);
  
  
    function safeNumber(value, fallback = 0) {
      if (value === null || value === undefined || value === '') return fallback;
      const num = typeof value === 'string' ? parseFloat(value.replace(/\D/g, '')) : Number(value);
      return isNaN(num) ? fallback : num;
    }
  
    function getInputValues() {
      const getValue = (selector) => {
        const element = document.querySelector(selector);
        return element?.value || '';
      };
  
      return {
        bottleType: getValue('.hulkapps_option.bottle-type input[type="hidden"]')?.split(' ')[0] || '',
        bottleTypeColor: getValue('.hulkapps_option.bottle-type input[type="hidden"]') || '',
        abvPercent: getValue('.hulkapps_option.abv input[type="hidden"]'),
        casesToOrder: safeNumber(getValue('.hulkapps_option.order-cases input[type="hidden"]')),
        collectionOrShipping: getValue('.hulkapps_option.shipping input[type="hidden"]'),
        spirit: getValue('.hulkapps_option.spirit input[type="hidden"]'),
        flavor1input: getValue('.hulkapps_option.flav-one input[type="hidden"]'),
        flavor2input: getValue('.hulkapps_option.flav-two input[type="hidden"]'),
        color: getValue('.hulkapps_option.colour input[type="hidden"]'),
        productName: getValue('.hulkapps_option.prod-name input[type="hidden"]'),
        labelDesign: getValue('.hulkapps_option.label-design input[type="hidden"]'),
        labelPrint: getValue('.hulkapps_option.label-print input[type="hidden"]'),
        productDevelopment: getValue('.hulkapps_option.prod-dev input[type="hidden"]'),
        productBrandPurpose: getValue('.hulkapps_option.brand-purpose input[type="hidden"]'),
        productionNotes: getValue('.hulkapps_option.prod-note input[type="hidden"]')
      };
    }
  
    // function changeImage(selectValue) {
    //   const imageMap = {
    //     'blue': 'https://cdn.shopify.com/s/files/1/0638/5798/3628/files/blue1.png?v=1755154962',
    //     'red': 'https://cdn.shopify.com/s/files/1/0638/5798/3628/files/red1.png?v=1755154962',
    //     'orange': 'https://cdn.shopify.com/s/files/1/0638/5798/3628/files/orange1.png?v=1755154962',
    //     'purple': 'https://cdn.shopify.com/s/files/1/0638/5798/3628/files/purple1.png?v=1755154962',
    //     'green': 'https://cdn.shopify.com/s/files/1/0638/5798/3628/files/green1.png?v=1755154962',
    //     'yellow': 'https://cdn.shopify.com/s/files/1/0638/5798/3628/files/yellow1.png?v=1755154962',
    //     'default': 'https://cdn.shopify.com/s/files/1/0638/5798/3628/files/Untitled-1.png?v=1755154962'
    //   };
  
    //   try {
    //     const bottleImage = document.getElementById('bottle-preview-image');
        
    //     if (!bottleImage) {
    //       console.warn('Bottle preview image element not found');
    //       return;
    //     }
  
    //     const normalizedValue = selectValue ? selectValue.toLowerCase().trim() : '';
        
    //     const newImageUrl = imageMap[normalizedValue] || imageMap['default'];
    //     bottleImage.src = newImageUrl;
        
    //     bottleImage.style.opacity = '0.7';
        
    //     bottleImage.onload = function() {
    //       this.style.opacity = '1';
    //     };
        
    //     bottleImage.onerror = function() {
    //       console.error(`Failed to load image: ${newImageUrl}`);
    //       this.src = imageMap['default'];
    //       this.style.opacity = '1';
    //     };
        
    //   } catch (error) {
    //     console.error('Error changing bottle image:', error);
    //   }
    // }

function changeImage(bottleTypeColor, selectedColor) {
  // Nested map: bottleTypeColor -> color -> imageURL
  const imageMap = {
    '70cl - Mixologist': {
      'blue': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/Blue_rhino_d735e80e-608f-4a2c-b712-344cafb1cd3b.png?v=1745390010',
      'purple': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/Purple_rhino_b5506f0d-6442-45a6-a248-479937566f39.png?v=1745390009',
      'red': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/Rhino_red_ecbe78f4-5e25-4adc-838d-ab59d5505d86.png?v=1745390009',
      'green': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/Rhino_green_a5f3e4df-1c03-429b-b48b-697888482cb2.png?v=1745390009',
      'yellow': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/Yellow_Rhino_8b05a7f2-36d6-4978-951e-ab57dd5bafc4.png?v=1760898046',
      'brown': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/Rhino_Brown_color.png?v=1760898046',
      'orange': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/Rhino_orange_color.png?v=1760898046',
      'default': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/Blue_rhino_d735e80e-608f-4a2c-b712-344cafb1cd3b.png?v=1745390010'
    },
    '70cl - Bamboo': {
      'green': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/G-green.png?v=1761166838',
      'brown': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/G-brown.png?v=1761167369',
      'blue': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/G-blue.png?v=1760676137',
      'purple': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/G-purple.png?v=1760676136',
      'yellow': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/g-_yellow.png?v=1760676136',
      'red': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/g-red.png?v=1760676136',
      'orange': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/g-orange.png?v=1760676137',
      'default': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/bamboo.png?v=1760719333'
    },
    '50cl - Orange Cap': {
      'brown': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/brown.png?v=1760676409',
      'green': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/green_815aa960-3a36-4451-bcf4-373992f8e716.png?v=1760676408',
      'purple': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/pur.png?v=1760676408',
      'red': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/red_928eb5af-08b8-4f9d-a34d-1c03b3259a6c.png?v=1760676408',
      'yellow': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/yellow_9ac099ab-e88f-4cdc-b39e-3c160a2968fa.png?v=1760676409',
      'blue': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/blue_c2ade420-1573-4ea3-b0b6-48ecd5b9ea2e.png?v=1760676408',
      'orange': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/orange_51916b08-409b-44e4-99b0-e06a197a0488.png?v=1760676408',
      'default': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/orange_cap.png?v=1760719334'
    },
    '50cl - Black Cap': {
      'green': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/Green_aec6c975-59db-4046-832a-4230e03afe83.png?v=1760898445',
      'yellow': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/Yellow_b085a905-7684-4412-9e15-1a46a4e92c8e.png?v=1760898444',
      'orange': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/Orange_f8d8bb72-931e-4dc2-a4bb-b94db48b09fe.png?v=1760898444',
      'purple': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/Purple.png?v=1760898442',
      'blue': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/Blue_0b35e45a-0c92-4d2a-a421-6525e43ea57f.png?v=1760898442',
      'red': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/Red_color.png?v=1760898441',
      'brown': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/Brown_2a956858-6b0e-4378-9034-a84fc012eacf.png?v=1760898440',
      'default': 'https://cdn.shopify.com/s/files/1/0908/4557/7581/files/Colorless.png?v=1760898441'
    }
  };

  // Fallback image if bottle type is not found
  const globalDefault = 'https://cdn.shopify.com/s/files/1/0638/5798/3628/files/Untitled-1.png?v=1755154962';

  try {
    const bottleImage = document.querySelector('.bottle-preview img') || document.getElementById('bottle-preview-image');
    
    if (!bottleImage) {
      console.warn('Bottle preview image element not found');
      return;
    }

    // Normalize inputs
    const normalizedBottleType = bottleTypeColor ? bottleTypeColor.trim() : '';
    const normalizedColor = selectedColor ? selectedColor.toLowerCase().trim() : '';

    // Get the color map for this bottle type
    const colorMap = imageMap[normalizedBottleType];
    
    let newImageUrl;
    
    if (colorMap) {
      // If we have a color map for this bottle type, look up the color
      newImageUrl = colorMap[normalizedColor] || colorMap['default'];
    } else {
      // If bottle type not found, use global default
      console.warn(`Bottle type "${normalizedBottleType}" not found in image map`);
      newImageUrl = globalDefault;
    }
    
    // Set image with fade effect
    bottleImage.style.opacity = '0.7';
    bottleImage.src = newImageUrl;
    
    bottleImage.onload = function() {
      this.style.opacity = '1';
    };
    
    bottleImage.onerror = function() {
      console.error(`Failed to load image: ${newImageUrl}`);
      // Try the default for this bottle type, or global default
      this.src = colorMap?.default || globalDefault;
      this.style.opacity = '1';
    };
    
  } catch (error) {
    console.error('Error changing bottle image:', error);
  }
}    
  
    function calculatePricing(inputs) {
      try {
        if (!inputs.bottleType || !CONFIG.pricingData[inputs.bottleType]) {
          console.warn('Invalid bottle type:', inputs.bottleType);
          return createEmptyPricingResult(inputs);
        }
  
        if (inputs.casesToOrder < 0) {
          console.warn('Invalid cases to order:', inputs.casesToOrder);
          return createEmptyPricingResult(inputs);
        }
  
        const config = CONFIG.pricingData[inputs.bottleType];
        const abvValue = safeNumber(inputs.abvPercent);
        
        // Get pricing components with fallbacks
        const bottlePrice = safeNumber(config.base_pricing[inputs.casesToOrder.toString()], 0);
        const duty = safeNumber(config.duty_table?.[abvValue], 0);
        const flavor1Cost = inputs.flavor1input ? safeNumber(config.flavor_1, 0) : 0;
        const flavor2Cost = inputs.flavor2input ? safeNumber(config.flavor_2, 0) : 0;
        const coloringCost = inputs.color ? safeNumber(config.coloring_cost, 0) : 0;
  
        // Calculate totals
        const costPerBottle = bottlePrice + duty + flavor1Cost + flavor2Cost + coloringCost;
        const costPerBottleVAT = costPerBottle * (1 + CONFIG.vatRate);
        const totalBottles = inputs.casesToOrder * 6;
        const totalExcludingVAT = costPerBottle * totalBottles;
  
        // NEW CALCULATIONS
        // BP RRP Sum = bottle price + duty + flavor1 + flavor2 + coloring cost
        const bpRrpHelper = (bottlePrice + duty + flavor1Cost + flavor2Cost + coloringCost)*1.8;
        const bpRrpSum = bpRrpHelper/1.2;
        
        // Margin per bottle = bottle price - cost per bottle (excluding VAT)
        const marginBottle = bpRrpSum - costPerBottle;
        
        // Gross profit margin for bottle = margin bottle / bottle price
        const grossProfitMarginBottle = marginBottle/bpRrpSum;
        
        // Determine shots based on bottle price
        const shots = bottlePrice === CONFIG.barConfig.shotsThreshold 
          ? CONFIG.barConfig.shotsIfAtThreshold 
          : CONFIG.barConfig.shotsOtherwise;
        
        // Cost of serve = cost per bottle (ex VAT) / shots
        const costOfServe = shots > 0 ? (costPerBottle / shots) : 0;
        
        // RRP of bar (constant)
        const rrpOfBar = CONFIG.barConfig.rrpOfBar;
        
        // Margin serve = RRP of bar - cost of serve
        const marginServe = rrpOfBar - costOfServe;
        
        // Gross profit margin for serve = margin serve / RRP of bar
        const grossProfitMarginServe = rrpOfBar > 0 ? (marginServe / rrpOfBar) : 0;
  
        const productDevelopmentCost = inputs.productDevelopment === "" || inputs.productDevelopment !== 'I would like 5 product samples before making a decision (please select 0 on question above)'
            ? CONFIG.productDevelopmentCosts.default
            : CONFIG.productDevelopmentCosts.SAMPLE;
  
        const isProductDevelopment = inputs.casesToOrder === 0 && inputs.productDevelopment === 'I would like 5 product samples before making a decision (please select 0 on question above)';
        const needsShipping = inputs.collectionOrShipping?.toLowerCase().includes('yes');
        const shippingCost = needsShipping ? safeNumber(CONFIG.shippingRates[inputs.casesToOrder.toString()], 0) : 0;
  
        const grandTotal = isProductDevelopment ? productDevelopmentCost :  totalExcludingVAT + productDevelopmentCost + shippingCost;
        const additionalGrandTotal = isProductDevelopment ? productDevelopmentCost :  totalExcludingVAT + productDevelopmentCost + safeNumber(shippingCost/1.2, 0);
        const totalIncludingVAT = isProductDevelopment ? additionalGrandTotal : additionalGrandTotal * (1 + CONFIG.vatRate);
  
        return {
          input: inputs,
          costs: {
            bottle_price: bottlePrice,
            duty: duty,
            flavor_1: flavor1Cost,
            flavor_2: flavor2Cost,
            coloring_cost: coloringCost,
            cost_per_bottle: costPerBottle,
            cost_per_bottleVAT: costPerBottleVAT,
            cases_to_order: inputs.casesToOrder,
            total_bottles: totalBottles,
            totalProduct: totalExcludingVAT,
            totalAdditional: additionalGrandTotal,
            totalIncludingVAT: totalIncludingVAT,
            product_development_cost: productDevelopmentCost,
            shipping_cost: shippingCost,
            // NEW FIELDS
            bp_rrp_sum: bpRrpSum,
            margin_bottle: marginBottle,
            gross_profit_margin_bottle: grossProfitMarginBottle,
            shots: shots,
            cost_of_serve: costOfServe,
            rrp_of_bar: rrpOfBar,
            margin_serve: marginServe,
            gross_profit_margin_serve: grossProfitMarginServe
          },
          total: {
            cart_total: isProductDevelopment ? additionalGrandTotal : totalIncludingVAT
          },
          isValid: true
        };
      } catch (error) {
        console.error('Error calculating pricing:', error);
        return createEmptyPricingResult(inputs);
      }
    }
  
    function createEmptyPricingResult(inputs) {
      return {
        input: inputs,
        costs: {
          bottle_price: 0,
          duty: 0,
          flavor_1: 0,
          flavor_2: 0,
          coloring_cost: 0,
          cost_per_bottle: 0,
          cost_per_bottleVAT: 0,
          cases_to_order: 0,
          total_bottles: 0,
          totalProduct: 0,
          totalAdditional: 0,
          totalIncludingVAT: 0,
          product_development_cost: 0,
          shipping_cost: 0,
          // NEW FIELDS
          bp_rrp_sum: 0,
          margin_bottle: 0,
          gross_profit_margin_bottle: 0,
          shots: 0,
          cost_of_serve: 0,
          rrp_of_bar: CONFIG.barConfig.rrpOfBar,
          margin_serve: 0,
          gross_profit_margin_serve: 0
        },
        total: {
          cart_total: 0
        },
        isValid: false
      };
    }
  
    function updateElement(selector, value, formatAsCurrency = true, isPercentage = false) {
      try {
        const element = document.querySelector(selector);
        if (!element) {
          console.warn(`Element not found: ${selector}`);
          return;
        }
  
        const numValue = safeNumber(value, 0);
        let displayValue;
        
        if (isPercentage) {
          displayValue = (numValue * 100).toFixed(2) + '%';
        } else if (formatAsCurrency) {
          displayValue = numValue.toFixed(2);
        } else {
          displayValue = numValue.toString();
        }
        
        element.textContent = displayValue;
      } catch (error) {
        console.error(`Error updating element ${selector}:`, error);
      }
    }
  
    function updateDOM(calculatedValue) {
      if (!calculatedValue || !calculatedValue.costs) {
        console.warn('Invalid calculated value for DOM update');
        return;
      }
  
      const costs = calculatedValue.costs;
      
      // Update existing pricing elements
      updateElement('#bottle-price', costs.bottle_price);
      updateElement('#duty-cost', costs.duty);
      updateElement('#flavour1-cost', costs.flavor_1);
      updateElement('#flavour2-cost', costs.flavor_2);
      updateElement('#colour-cost', costs.coloring_cost);
      updateElement('#bottle-cost-ex', costs.cost_per_bottle);
      updateElement('#bottle-cost-inc', costs.cost_per_bottleVAT);
      updateElement('#cases-display', costs.cases_to_order, false);
      updateElement('#bottles-display', costs.total_bottles, false);
      updateElement('#total-cost-product', costs.totalProduct);
      updateElement('#total-cost-ex', costs.totalAdditional);
      updateElement('#total-cost-inc', costs.totalIncludingVAT);
      updateElement('#development-cost', costs.product_development_cost);
      updateElement('#shipping-cost', costs.shipping_cost);
      
      // Update NEW pricing elements
      updateElement('#bp-rrp-sum', costs.bp_rrp_sum);
      updateElement('#margin-bottle', costs.margin_bottle);
      updateElement('#gross-profit-margin-bottle', costs.gross_profit_margin_bottle, false, true);
    //   updateElement('#shots', costs.shots, false);
      updateElement('#cost-of-serve', costs.cost_of_serve);
      updateElement('#rrp-of-bar', costs.rrp_of_bar);
      updateElement('#margin-serve', costs.margin_serve);
      updateElement('#gross-profit-margin-serve', costs.gross_profit_margin_serve, false, true);
    }
  
    function updatePage(calculatedValue) {
      if (!calculatedValue || !calculatedValue.total) {
        console.warn('Invalid calculated value for page update');
        return;
      }
  
      try {
        if (calculatedValue.input.flavor1input == "") {
          calculatedValue.costs.flavor_1 = 0;
        }
        if (calculatedValue.input.flavor2input == "") {
          calculatedValue.costs.flavor_2 = 0;
        }
        
        if (calculatedValue.input.casesToOrder == 0 && calculatedValue.input.productDevelopment == 'I would like 5 product samples before making a decision (please select 0 on question above)') {
          calculatedValue.total.cart_total = 162.50;
        }
  
        const priceInput = hulkFormulaEle?.querySelector('.hulk-form-field:nth-child(2) input');
        if (priceInput) {
          const $priceInput = $(priceInput);
          $priceInput.val(calculatedValue.total.cart_total);
          $priceInput.change();
          
          if (typeof window.calc_options_total === 'function') {
            window.calc_options_total();
          }
        }
      } catch (error) {
        console.error('Error updating page:', error);
      }
    }
  
    /**
     * Handle form changes with debouncing
     */
    let updateTimeout;
  
    // function handleFormChange() {
    //   clearTimeout(updateTimeout);
    //   updateTimeout = setTimeout(() => {
    //     try {
    //       const inputs = getInputValues();
    //       const calculatedValue = calculatePricing(inputs);
          
    //       // Update the bottle image based on color selection
    //       if (inputs.color) {
    //         changeImage(inputs.color);
    //       }
          
    //       if (calculatedValue.isValid || inputs.casesToOrder === 0) {
    //         updateDOM(calculatedValue);
    //         updatePage(calculatedValue); 
    //       }
    //     } catch (error) {
    //       console.error('Error handling form change:', error);
    //     }
    //   }, 100);
    // }

function handleFormChange() {
  clearTimeout(updateTimeout);
  updateTimeout = setTimeout(() => {
    try {
      const inputs = getInputValues();
      const calculatedValue = calculatePricing(inputs);
      
      // Update the bottle image based on bottle type AND color selection
      if (inputs.bottleTypeColor && inputs.color) {
        changeImage(inputs.bottleTypeColor, inputs.color);
      } else if (inputs.bottleTypeColor) {
        // Show default image for bottle type if no color selected
        changeImage(inputs.bottleTypeColor, '');
      }
      
      if (calculatedValue.isValid || inputs.casesToOrder === 0) {
        updateDOM(calculatedValue);
        updatePage(calculatedValue);
      }
    } catch (error) {
      console.error('Error handling form change:', error);
    }
  }, 100);
}
  
    // Make handleFormChange accessible globally for product development handler
    window.hulkForceUpdate = handleFormChange;
  
    function setupObservers() {
      try {
        const elementsToMonitor = document.querySelectorAll('.hulkapps_option:not(.fm_render) input[type="hidden"]');
        
        if (elementsToMonitor.length === 0) {
          console.warn('No elements found to monitor');
          return;
        }
  
        const config = { attributes: true, attributeFilter: ['value'] };
        
        elementsToMonitor.forEach((element) => {
          const observer = new MutationObserver(handleFormChange);
          observer.observe(element, config);
        });
        
      } catch (error) {
        console.error('Error setting up observers:', error);
      }
    }
  
    setupObservers();
  }

  function labelPreview() {
    const prodNameInput = document.querySelector('.prod-name input');
    const hulkLabelPreview = document.querySelector('.hulk-label-preview');

    prodNameInput.addEventListener('input', function() {
      let text = this.value.substring(0, 30);
      let formattedText = text.split(' ').join('<br>');
      hulkLabelPreview.innerHTML = formattedText;
      
      if (this.value.length > 30) {
        this.value = text;
      }
    });
  }
  
  
  function setupPurposeHandler() {
    const giftNote = document.getElementById('gift-note');
    const publicNote = document.getElementById('public-note');
    const awrsNote = document.getElementById('awrs-note');
    const purposeSelect = document.querySelector('select[aria-label="Product/Brand Purpose"]');
    const hiddenInput = document.querySelector('input[name="properties[Product/Brand Purpose]"]');
  
    [giftNote, publicNote, awrsNote].forEach(note => {
      if (note) note.style.display = 'none';
    });
  
    if (!purposeSelect) return;
  
    purposeSelect.addEventListener('change', function() {
      // Hide all notes
      [giftNote, publicNote, awrsNote].forEach(note => {
        if (note) note.style.display = 'none';
      });
  
      const selectedValue = this.value;
      
      if (hiddenInput) {
        hiddenInput.value = selectedValue;
      }
      
      // Show appropriate note
      switch(selectedValue) {
        case 'Gifting/Not for resale':
          if (giftNote) giftNote.style.display = 'block';
          break;
        case 'I want to sell to the public':
          if (publicNote) publicNote.style.display = 'block';
          break;
        case 'I want to sell to businesses and the public':
          if (awrsNote) awrsNote.style.display = 'block';
          break;
      }
    });
  }
  
  /**
   * Handle product development changes
   */
  function setupProductDevelopmentHandler() {
    const prodDev = document.querySelector('select[aria-label="Product Development"]');
    const prodHidden = document.querySelector('input[name="properties[Product Development]"]');
    const quantitySelect = document.querySelector('select[aria-label="Cases to Order (6 bottles per case)"]');
    const quantityHidden = document.querySelector('input[name*="properties[Cases to Order (6 bottles per case)"]');
      
    if (!prodDev) return;
  
    prodDev.addEventListener('change', function() {
      const selectedValue = this.value;
      
      if (prodHidden) {
        prodHidden.value = selectedValue;
      }
      
      if (selectedValue === 'I would like 5 product samples before making a decision (please select 0 on question above)') {
        if (quantitySelect) quantitySelect.value = '0';
        if (quantityHidden) {
          quantityHidden.value = '0';
          // Trigger change event to update calculations
          const event = new Event('change', { bubbles: true });
          quantityHidden.dispatchEvent(event);
        }
      }
    });
  }
  
  /**
   * Initialize everything when page loads
   */
  window.addEventListener('load', () => {
    
    const hook = setInterval(() => {
      const hulkDiv = document.querySelector('div[id^="hulkapps_custom_options"]');
      if (hulkDiv) {
        clearInterval(hook);
        console.log('HulkApps div found - initializing');
        hulkapps_custom_init();
        setupPurposeHandler();
        setupProductDevelopmentHandler();
        labelPreview();
      }
    }, 500);
    
    // Clear interval after 15 seconds to prevent infinite checking
    setTimeout(() => {
      clearInterval(hook);
    }, 15000);
  });